import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Droplet, Award, Heart, ChevronLeft, ChevronRight } from 'lucide-react';
import { heroImages } from '../mock';

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroSlides = [
    {
      image: 'https://customer-assets.emergentagent.com/job_web-collaborator/artifacts/smn5wunr_Pekala.png',
      title: 'Pekâlâ\'ya',
      highlight: 'Hoş Geldiniz',
      description: 'Tazeliğin kaynağından sofranıza. Süt ürünleri ve içeceklerde lezzetin en âlâsını sunuyoruz.'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_web-collaborator/artifacts/f8go7gsj_Final%20Hero%20Banner%20T%C3%BCm%20%C3%9Cr%C3%BCnler.png',
      title: 'Doğallığın ve',
      highlight: 'Lezzetin Âlâsı',
      description: 'En taze malzemelerle üretilen, ailenizin güvenle tüketebileceği doğal ürünler.'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_site-setup-2/artifacts/5x0o7gnf_Yaz%20%C4%B0%C3%A7ecekleri%20Tan%C4%B1t%C4%B1m%20Banner.png',
      title: 'Yaz Serinliği',
      highlight: 'Pekâlâ Limonata ve Vişne',
      description: 'Sıcak yaz günlerinin vazgeçilmezi! Doğal limonata ve vişne aromalı içeceklerimizle serinleyin.'
    },
    {
      image: heroImages.main,
      title: 'Geleneksel',
      highlight: 'Lezzet',
      description: 'Ev yapımı lezzetler modern hijyen standartlarıyla buluşuyor.'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [heroSlides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  };
  const categories = [
    {
      title: 'Süt Ürünleri',
      description: 'En taze sütlerden üretilen ayran ve yoğurt',
      image: 'https://customer-assets.emergentagent.com/job_dairy-site-collab/artifacts/1m4i7nx7_Ayran%20Bardak%201344x768.png',
      link: '/products?category=süt',
      color: 'from-blue-50 via-white to-sky-50'
    },
    {
      title: 'Taze İçecekler',
      description: 'Limon ve vişne aromalı içecekler',
      image: 'https://customer-assets.emergentagent.com/job_dairy-site-collab/artifacts/s6o6kwm5_Pekala%20Vi%C5%9Fne%20Limonata%20Floating%20Parallax_1.png',
      link: '/products?category=içecek',
      color: 'from-amber-50 via-white to-yellow-50'
    },
    {
      title: 'Yerli Üretim',
      description: 'Günlük tazelik, doğal lezzet',
      icon: Award,
      link: '/quality',
      color: 'from-green-50 via-white to-emerald-50'
    }
  ];

  const features = [
    {
      icon: Droplet,
      title: 'Doğal İçerikler',
      description: 'Katkısız, doğal malzemelerle üretim'
    },
    {
      icon: Award,
      title: 'Kalite Güvencesi',
      description: 'Okul gıdası onaylı, güvenli ürünler'
    },
    {
      icon: Heart,
      title: 'Geleneksel Lezzet',
      description: 'Ev yapımı lezzetler, modern hijyen'
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section with Carousel */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        {/* Slides */}
        {heroSlides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <div 
              className="absolute inset-0 z-0"
              style={{
                backgroundImage: `url(${slide.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#216DB8]/80 via-[#216DB8]/70 to-[#216DB8]/80 z-0" />
          </div>
        ))}

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 animate-fade-in drop-shadow-2xl">
            {heroSlides[currentSlide].title} <span className="text-green-400">{heroSlides[currentSlide].highlight}</span>
          </h1>
          <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto drop-shadow-lg">
            {heroSlides[currentSlide].description}
          </p>
          <Link
            to="/products"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-full font-bold hover:from-green-600 hover:to-green-700 transition-all duration-300 hover:scale-105 shadow-2xl hover:shadow-green-500/50"
          >
            Ürünlerimizi Keşfedin
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 -translate-y-1/2 z-20 p-3 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full transition-all duration-300 group"
          aria-label="Previous slide"
        >
          <ChevronLeft className="h-8 w-8 text-white group-hover:scale-110 transition-transform" />
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 -translate-y-1/2 z-20 p-3 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full transition-all duration-300 group"
          aria-label="Next slide"
        >
          <ChevronRight className="h-8 w-8 text-white group-hover:scale-110 transition-transform" />
        </button>

        {/* Slide Indicators */}
        <div className="absolute bottom-24 left-1/2 -translate-x-1/2 z-20 flex space-x-3">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentSlide 
                  ? 'bg-white w-8' 
                  : 'bg-white/50 hover:bg-white/75'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
          <div className="w-6 h-10 border-2 border-white/60 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-white/60 rounded-full mt-2 animate-pulse" />
          </div>
        </div>
      </section>

      {/* From Farm to Table Journey Section */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Title */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Çiftlikten Sofranıza
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Her Pekala ürünü, doğallık ve kaliteyi koruyan bir yolculuktan geçer
            </p>
          </div>

          {/* Journey Steps */}
          <div className="relative">
            {/* Connection Line */}
            <div className="hidden md:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-[#216DB8] via-green-500 to-[#216DB8] transform -translate-y-1/2 z-0"></div>
            
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative z-10">
              {/* Step 1: Farm */}
              <div className="group relative">
                <div className="bg-white rounded-3xl shadow-lg overflow-hidden transform transition-all duration-500 hover:scale-105 hover:shadow-2xl">
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src="https://images.unsplash.com/photo-1500595046743-cd271d694d30?w=800&q=80"
                      alt="Çiftlik"
                      className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#216DB8]/80 to-transparent"></div>
                    <div className="absolute top-4 right-4 w-12 h-12 bg-white rounded-full flex items-center justify-center font-bold text-[#216DB8] shadow-lg">
                      1
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Çiftlik</h3>
                    <p className="text-sm text-gray-600">
                      En taze sütler ve kaliteli malzemeler günlük olarak toplanır
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 2: Production */}
              <div className="group relative md:mt-12">
                <div className="bg-white rounded-3xl shadow-lg overflow-hidden transform transition-all duration-500 hover:scale-105 hover:shadow-2xl">
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src="https://customer-assets.emergentagent.com/job_dairy-site-collab/artifacts/qc287tat_uretim.jpg"
                      alt="Üretim"
                      className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-green-600/80 to-transparent"></div>
                    <div className="absolute top-4 right-4 w-12 h-12 bg-white rounded-full flex items-center justify-center font-bold text-green-600 shadow-lg">
                      2
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Üretim</h3>
                    <p className="text-sm text-gray-600">
                      Modern tesislerde hijyenik koşullarda işlenir ve ambalajlanır
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 3: Quality Control */}
              <div className="group relative">
                <div className="bg-white rounded-3xl shadow-lg overflow-hidden transform transition-all duration-500 hover:scale-105 hover:shadow-2xl">
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src="https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=800&q=80"
                      alt="Kalite Kontrol"
                      className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#216DB8]/80 to-transparent"></div>
                    <div className="absolute top-4 right-4 w-12 h-12 bg-white rounded-full flex items-center justify-center font-bold text-[#216DB8] shadow-lg">
                      3
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Kalite Kontrol</h3>
                    <p className="text-sm text-gray-600">
                      Her ürün titiz kalite testlerinden başarıyla geçer
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 4: Delivery */}
              <div className="group relative md:mt-12">
                <div className="bg-white rounded-3xl shadow-lg overflow-hidden transform transition-all duration-500 hover:scale-105 hover:shadow-2xl">
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src="https://customer-assets.emergentagent.com/job_dairy-site-collab/artifacts/1skdocxz_%C3%96%C4%9Frenci%20Okul%20Ayran.png"
                      alt="Sofranıza"
                      className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-green-600/80 to-transparent"></div>
                    <div className="absolute top-4 right-4 w-12 h-12 bg-white rounded-full flex items-center justify-center font-bold text-green-600 shadow-lg">
                      4
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Sofranıza</h3>
                    <p className="text-sm text-gray-600">
                      Taze ve güvenli ürünler ailenizle buluşur
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Stats Counter */}
          <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-[#216DB8] mb-2">4+</div>
              <p className="text-gray-600 font-medium">Yıllık Tecrübe</p>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-green-600 mb-2">100%</div>
              <p className="text-gray-600 font-medium">Doğal İçerik</p>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-[#216DB8] mb-2">1000+</div>
              <p className="text-gray-600 font-medium">Mutlu Müşteri</p>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-green-600 mb-2">24/7</div>
              <p className="text-gray-600 font-medium">Taze Üretim</p>
            </div>
          </div>

        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Neden Pekâlâ?
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Kalite, doğallık ve güven bir arada
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div
                  key={index}
                  className="text-center p-8 rounded-2xl hover:bg-gradient-to-br hover:from-blue-50 hover:to-green-50 transition-all duration-300 group border-2 border-transparent hover:border-blue-100"
                >
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#216DB8] to-green-100 rounded-full mb-6 group-hover:scale-110 group-hover:shadow-lg transition-all duration-300">
                    <Icon className="h-8 w-8 text-[#216DB8]" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                  <p className="text-gray-600">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Ürün Kategorilerimiz
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Süt ürünlerinden taze içeceklere kadar geniş bir ürün yelpazesi
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {categories.map((category, index) => (
              <Link
                key={index}
                to={category.link}
                className="group relative overflow-hidden rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
              >
                <div className={`bg-gradient-to-br ${category.color} p-8 h-full min-h-[400px] flex flex-col justify-between`}>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">
                      {category.title}
                    </h3>
                    <p className="text-gray-700 mb-6">{category.description}</p>
                  </div>

                  {category.image ? (
                    <div className="flex justify-center items-center flex-1">
                      <img
                        src={category.image}
                        alt={category.title}
                        className="h-48 w-auto object-contain group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                  ) : category.icon ? (
                    <div className="flex justify-center items-center flex-1">
                      <category.icon className="h-32 w-32 text-emerald-600 opacity-80 group-hover:scale-110 transition-transform duration-500" />
                    </div>
                  ) : null}

                  <div className="flex items-center text-[#216DB8] font-semibold mt-4 group-hover:text-green-600">
                    Keşfet
                    <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-2 transition-transform duration-300" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Brand Promise Section */}
      <section className="relative py-32 overflow-hidden">
        <div 
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: `url(${heroImages.quality1})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 via-green-800/85 to-blue-900/90" />
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Tazeliğin Kaynağından Sofranıza
          </h2>
          <p className="text-xl text-gray-100 leading-relaxed mb-8">
            Pekâlâ olarak, en taze sütleri ve en sulu meyveleri seçiyor, lezzetin en âlâsını sunmak için özenle işliyoruz. Her ürünümüz, doğallık ve kalite taahhüdümüzün bir yansımasıdır.
          </p>
          <Link
            to="/quality"
            className="inline-flex items-center px-8 py-4 bg-white text-[#216DB8] rounded-full font-bold hover:bg-gray-100 transition-all duration-300 hover:scale-105 shadow-2xl hover:shadow-white/30"
          >
            Hikayemizi Okuyun
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
